import { computed, unref } from 'vue';

import { classesStates, propsFactory } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export interface ILoadingProps {
  loading: boolean;
}
export interface IUseLoading {
  loadingClasses: ComputedRef<string | undefined>;
  hasLoading: ComputedRef<boolean>;
}

export const makeLoadingProps = propsFactory(
  {
    /**
     * Состояние загрузки
     */
    loading: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'loading'
);

export function useLoading(props: ILoadingProps): IUseLoading {
  const hasLoading = computed(() => props.loading);
  const loadingClasses = computed(() => {
    const { loading } = unref(props);
    return loading ? classesStates.loading : undefined;
  });

  return { hasLoading, loadingClasses };
}
